import Loading from 'Shared/Loading'

const PageLoading = () => (
  <Loading className="d-flex flex-fill align-items-center justify-content-center" />
)

export default PageLoading
